var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 22.75,
    fill: "#FFFAE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 22.75,
    stroke: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1872 28.5538L24.008 27.3324L26.9982 24.3423H16.7643V22.6577H26.9982L24.008 19.6676L25.1872 18.4462L30.241 23.5L25.1872 28.5538Z",
    fill: "#EF8551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11);
export default __webpack_public_path__ + "static/media/frame-11.a876ef8c287d275d75c3ec2a985c5253.svg";
export { ForwardRef as ReactComponent };